import Vocabulary from "../../../../Common/Vocabulary";

export class ClientForm {
    constructor() {
        this._lang = $('html').attr('lang');

        this._tariffOptions = [
            {
                val: 0,
                text: '30 000',
            },
            {
                val: 1,
                text: '50 000',
            },
            {
                val: 2,
                text: '60 000',
            },
            {
                val: 3,
                text: '100 000',
            },
        ];
    }

    getTemplate(client) {
        let tarifOptions = '';
        this._tariffOptions.forEach(option => {
            if (client.mz_insurance_sum == option.val) {
                tarifOptions += `
                    <option selected value='${option.val}'>${option.text}</option>
                `;
            } else {
                tarifOptions += `
                    <option value='${option.val}'>${option.text}</option>
                `;
            }


        });

        return `
            <div class="checkout_form_row" data-client="${client.id}">
                <div class="checkout_form_row_title">${Vocabulary[this._lang].traveling} ${client.id}</div>
                <div class="checkout_form_field _required">
                    <label for="client-${client.id}">${Vocabulary[this._lang].birthday}</label>
                    <input required readonly class="_input" id="client-${client.id}" name="clients[${client.id}]born_date" type="text" value="${client.born_date.format('yyyy-MM-DD')}">
                </div>
                <div class="checkout_form_field _required">
                    <label for="insurance-client-${client.id}">${Vocabulary[this._lang].insurance_sum}</label>
                    <select required id="insurance-client-${client.id}" name='clients[${client.id}]mz_insurance_sum' class="selectize select1 mzInsuranceSelect">
                        ${tarifOptions}
                    </select>
                </div>
            </div>
        `;
    }
}